import * as React from "react";
import { XCircle } from "react-feather";
import { useMsal } from "@azure/msal-react";

interface AuthErrorProps {
  message: string;
}

const AuthError: React.FC<AuthErrorProps> = props => {
  const { instance } = useMsal();

  return (
    <div className="o-overlay d-flex flex-column justify-content-center align-items-center px-3 py-5">
      <div className="text-secondary">
        <XCircle size={48} />
      </div>
      <div className="text-secondary text-center fs-7 mt-4">
        {props.message}
      </div>
      <div className="d-flex align-items-center mt-5">
        <a href="#0" className="ml-2 fs-8" onClick={(e) => {
          e.preventDefault();
          instance.loginRedirect();
        }}>Return to login</a>
      </div>
    </div>
  );
};

export default AuthError;
